import { useField } from "@formiz/core";
import { Checkbox } from "@nextui-org/react";

const CheckboxField = (props) => {
  const { setValue, value, otherProps } = useField(props);

  return <Checkbox className="text-white" onChange={() => setValue(!value)} {...otherProps}></Checkbox>;
};

export default CheckboxField;
